//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetPartition",{R_:{partition:"Assemblies.Partition"}},0,0],[["num","members"],"GetMemberInfo",{},0,0]],[]];
SPLM.Assemblies.IsPartitionableResult = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.IsPartitionableResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.IsPartitionableResult.MemberInfo = class{
    constructor(component,isPartitionable,reason){
        this.component=component;this.isPartitionable=isPartitionable;this.reason=reason;}
    get Component(){return this.component}
    set Component(val){this.component = val}
    get Ispartitionable(){return this.isPartitionable}
    set Ispartitionable(val){this.isPartitionable = val}
    get Reason(){return this.reason}
    set Reason(val){this.reason = val}
};

export default SPLM;